'use strict';

var NetworkError = require('./NetworkError.js');

class LockedError extends NetworkError.NetworkError {
    constructor(message = 'Locked') {
        super(message, 423);
    }
}

exports.LockedError = LockedError;
//# sourceMappingURL=LockedError.js.map
